import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './PopoverSection.module.css';

const bindClasses = classNameBind.bind(styles);

const PopoverSection = ({
  fixedHeight,
  padding,
  children,
}) => (
  <div className={bindClasses('wrapper', padding, { fixedHeight })}>
    {children}
  </div>
);

PopoverSection.defaultProps = {
  padding: 'none',
  fixedHeight: false,
};

PopoverSection.displayName = 'Popover.Section';

export default PopoverSection;
